import {ViewTreeAuthorDrawer} from './ViewTreeAuthorDrawer'

export default ViewTreeAuthorDrawer
